import { getLanguage as parseLanguageFromI18nCode, Languages } from "@/constants/languages";

const I18NEXT_LANG_STORAGE_KEY = "i18nextLng";

/**
 * PSG team-offer redeem flow is localized to EN and FR only.
 * Any other resolved UI language (DE, ES, PT, etc.) maps to English.
 */
export const resolvePsgRedeemDisplayLanguage = (
    languageCode: string
): Languages.English | Languages.French =>
    parseLanguageFromI18nCode(languageCode) === Languages.French
        ? Languages.French
        : Languages.English;

/** Best-effort hint before i18n has finished initializing (localStorage, then navigator). */
export const readLanguageHintForInit = (): string => {
    if (typeof window === "undefined") {
        return "";
    }
    try {
        const fromStorage = localStorage.getItem(I18NEXT_LANG_STORAGE_KEY);
        if (fromStorage) {
            return fromStorage;
        }
    } catch {
        // ignore storage access errors
    }
    return typeof navigator !== "undefined" ? navigator.language : "";
};
